import styled from "styled-components";

export const StyledBodyProfessionalPathDevelopment = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
